import React from 'react'

function Calendar(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0.12 0.12 17.17 17.17"
            height={props.height}
            width={props.width}
        >
            <path
                fill={props.colorOne}
                d="M17.17 2.08h-1.79v-.6c0-.77-.59-1.36-1.3-1.36s-1.3.6-1.3 1.37v.59H4.62v-.6c0-.77-.6-1.36-1.3-1.36-.72 0-1.31.6-1.31 1.37v.53H.24v3.5h17.05l-.12-3.44zm-13.07.6c0 .53-.36.88-.83.88s-.9-.35-.9-.89V1.5c0-.48.42-.9.9-.9.47 0 .89.42.89.9v1.18H4.1zm13.07 3.44v11.16H.12V6.13h17.05zM8.14 13.3h-1.9v1.72h1.9V13.3zm-3.1 0h-1.9v1.72h1.9V13.3zm6.19 0h-1.9v1.72h1.9V13.3zm2.85 0h-1.9v1.72h1.9V13.3zm-5.94-2.86h-1.9v1.73h1.9v-1.72zm3.09 0h-1.9v1.73h1.9v-1.72zm2.85 0h-1.9v1.73h1.9v-1.72zm-9.03 0h-1.9v1.73h1.9v-1.72zm3.09-2.79h-1.9V9.4h1.9V7.66zm-3.1 0h-1.9V9.4h1.9V7.66zm6.19 0h-1.9V9.4h1.9V7.66zm2.85 0h-1.9V9.4h1.9V7.66zm0-7.07c.47 0 .89.42.89.9v1.18c0 .48-.42.9-.9.9a.91.91 0 01-.88-.9V1.5c0-.48.41-.9.89-.9z"
            />
        </svg>
    )
}

export default Calendar
